import { Navigate  } from 'react-router-dom'

import { getCookie } from './utils/manageCookie'

import { Home } from './pages'

const AutoLoginRoute = () => {
  const user = getCookie('akive_user')

  return(
    user?.accessToken ? <Navigate to='/main' replace={true}></Navigate> : <Home/>
  )
}

export default AutoLoginRoute